const styles = theme => ({
  imageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageHeader: {
    color: 'var(--mcg-dark, #002E47)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  imageText: {
    color: 'var(--mcg-gray, #919EAB)',
    /* Body/Body 6 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px' /* 163.636% */,
  },
  colorControlsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignSelf: 'stretch',
  },
  colorRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  colorField: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: '1 0 0',
  },
  colorLabel: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px',
  },
  colorInputContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  colorPickerBg: {
    width: '32px',
    height: '32px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    borderRadius: '8px',
    cursor: 'pointer',
    padding: '0',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      borderColor: '#015FFB',
    },
  },
  colorPickerSpan: {
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  popover: {
    '& .MuiPopover-paper': {
      borderRadius: '8px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    },
  },
  colorTextInput: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '& fieldset': {
        borderColor: 'var(--Gray-Lighter, #E5E7EB)',
      },
      '&:hover fieldset': {
        borderColor: '#015FFB',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#015FFB',
      },
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
      fontFamily: 'Inter',
      color: 'var(--mcg-dark, #002E47)',
    },
  },
})

export default styles
